document.querySelectorAll('.gs').forEach(root=>{
 if(root.dataset.gsReady)return;
 root.dataset.gsReady='true';
 root.addEventListener('click',event=>{
  const thumb=event.target.closest('[data-gs-image]');
  if(thumb){
   const gallery=thumb.closest('[data-gs-gallery]');
   const image=gallery.querySelector('.gs-gallery-main img');
   const url=thumb.dataset.gsImage;
   image.src=url+'?width=1200';
   image.srcset=[480,800,1200,1800].map(w=>url+'?width='+w+' '+w+'w').join(', ');
   image.alt=thumb.dataset.gsAlt;
   gallery.querySelector('.gs-gallery-main').href=url;
   gallery.querySelector('.gs-gallery-caption').textContent=thumb.dataset.gsCaption;
   gallery.querySelectorAll('[data-gs-image]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
  }
  const choice=event.target.closest('a[data-gs-choose],a[data-gs-service]');
  if(choice){
   const pack=root.querySelector('select[data-gs-package]');
   const intent=root.querySelector('select[data-gs-intent]');
   const service=root.querySelector('select[data-gs-service]');
   if(choice.dataset.gsChoose)pack.value=choice.dataset.gsChoose;
   if(choice.dataset.gsIntent)intent.value=choice.dataset.gsIntent;
   if(choice.dataset.gsService)service.value=choice.dataset.gsService;
  }
 });
 const model=root.querySelector('[data-gs-model]');
 const models=root.querySelectorAll('[data-gs-model]');
 if(models.length===1&&model){
  const select=root.querySelector('select[data-gs-package]');
  if(select)select.value=model.dataset.gsModel;
 }
});
document.querySelectorAll('.gs').forEach(root=>{
 const models=Array.from(root.querySelectorAll('[data-gs-model]'));
 const packageSelect=root.querySelector('[data-gs-package]');
 const summaryInput=root.querySelector('[data-leil-summary]');
 const summaryText=root.querySelector('[data-leil-form-summary]');
 const money=new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'});
 const format=cents=>money.format(cents/100)+' CAD';
 function state(model){
  const config=model.querySelector('[data-leil-config]');
  const choices=Array.from(config.querySelectorAll('[data-leil-option]'));
  const selected=choices.map(select=>select.selectedOptions[0]);
  const total=Number(config.dataset.base)+selected.reduce((sum,opt)=>sum+Number(opt.dataset.price||0),0);
  const quote=selected.some(opt=>opt.dataset.quote==='true');
  return {config,choices,selected,total,quote};
 }
 function update(model){
  const current=state(model);
  model.querySelector('[data-leil-total]').textContent=current.config.dataset.quoteOnly==='true'?current.config.dataset.quoteLabel:format(current.total);
  current.config.querySelector('[data-quote-note]').hidden=!current.quote;
  current.config.querySelector('[data-heater-details]').hidden=current.choices.find(select=>select.dataset.leilOption==='heat').selectedIndex===0;
 }
 function sync(){
  const model=models.find(item=>item.dataset.gsModel===packageSelect?.value);
  if(!model){if(summaryInput)summaryInput.value='';if(summaryText)summaryText.textContent='';return;}
  const current=state(model);
  const lines=[model.querySelector('h1,h2').textContent.trim()];
  current.choices.forEach((select,i)=>{
   const label=select.previousElementSibling.textContent.trim();
   lines.push(label+': '+current.selected[i].textContent.trim());
  });
  lines.push(model.querySelector('.gs-price-box .gs-eyebrow').textContent.trim()+': '+(current.config.dataset.quoteOnly==='true'?current.config.dataset.quoteLabel:format(current.total)));
  lines.push(model.querySelector('.gs-delivery').textContent.trim());
  if(current.quote)lines.push(current.config.querySelector('[data-quote-note]').textContent.trim());
  if(summaryInput)summaryInput.value=lines.join('\n');
  if(summaryText)summaryText.textContent=lines.join(' · ');
 }
 models.forEach(update);
 root.addEventListener('change',event=>{
  const model=event.target.closest('[data-gs-model]');
  if(model&&event.target.matches('[data-leil-option]')){update(model);if(packageSelect)packageSelect.value=model.dataset.gsModel;}
  sync();
 });
 root.addEventListener('click',event=>{if(event.target.closest('[data-gs-choose]'))sync();});
 root.querySelector('form')?.addEventListener('submit',sync);
 sync();
});



document.querySelectorAll('.gs').forEach(root=>{root.addEventListener('change',event=>{const select=event.target.closest('[data-leil-option="size"]');if(!select)return;const model=select.closest('[data-gs-model]');const chosen=select.selectedOptions[0];[['exterior','[data-exp-exterior]'],['interior','[data-exp-interior]'],['weight','[data-exp-weight]']].forEach(([key,target])=>{const node=model.querySelector(target);if(node)node.textContent=chosen.dataset[key];});});});
